import { SxProps, Theme } from "@mui/material/styles";

const styles: Record<string, SxProps<Theme>> = {
  root: {
    margin: "24px",
    display: "flex",
    gap: "24px",
  },
  icon: {
    width: "24px",
    height: "24px",
    mt: 0.5,
  },
  action: {
    display: "flex",
    mb: 3,
    backgroundColor: "background.paper",
    p: 2,
    borderRadius: 2,
    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
  },
  textBlock: {
    flex: 1,
    minWidth: 0,
    maxWidth: "40%",
  },
  image: {
    flex: 1,
    minWidth: 0,
    maxWidth: "40%",
    "img": {
      width: "100%",
      height: "auto",
      objectFit: "contain",
      borderRadius: 2,
    }
  },
  title: {
    fontSize: "1.1rem",
    fontWeight: 600,
    color: "text.primary",
    mb: 1.5,
  },
  subtitle: {
    fontSize: "0.9rem",
    color: "text.secondary",
    mb: 1,
    lineHeight: 1.5,
  },
  actionTitle: {
    fontSize: "1rem",
    fontWeight: 600,
    color: "text.primary",
    mb: 1,
  },
  actionText: {
    fontSize: "0.9rem",
    color: "text.secondary",
    lineHeight: 1.5,
    mb: 2,
  },
  buttonContainer: {
    mt: 2,
    display: "flex",
    gap: 1,
  },
  button: {
    textTransform: "none",
    fontWeight: 500,
    px: 2,
  },
  chip: {
    fontWeight: 600,
    borderWidth: 1,
    borderRadius: "50%",
    width: 28,
    height: 28,
    "& .MuiChip-label": {
      px: 0,
      fontSize: "0.75rem"
    }
  },
  link: {
    color: "primary.main",
    textDecoration: "none",
    fontWeight: 600
  }
};

export default styles;
